import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { get, toNumber } from 'lodash'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  PaymentPrices,
  PaymentMethods
  // PaymentThreshold
} from 'components/sections/payments'
import { Form } from 'components/layout'
import { ConfigLoader } from 'components/loaders'
import { apiPayments, apiConfiguration, apiContacts } from 'helpers/decorators/api'
import { form, permissions as appPermissions } from 'helpers/decorators'
import { CONFIGURATION_KEYS } from 'constants/enums'

const enhance = compose(
  connect(({ api }) => ({
    organizations: api.organizations
  })),
  apiPayments(),
  appPermissions(),
  apiConfiguration({
    getValues: [
      // CONFIGURATION_KEYS.paymentLinkThreshold.id,
      CONFIGURATION_KEYS.onlineManualPayment.id,
      CONFIGURATION_KEYS.onlineMasterCardPayment.id,
      CONFIGURATION_KEYS.onlinePayPalPayment.id,
      CONFIGURATION_KEYS.directPayment.id,
      CONFIGURATION_KEYS.notRequiredPayment.id,
      CONFIGURATION_KEYS.directTransferPayment.id,
      CONFIGURATION_KEYS.gpWebPayPayment.id,
      CONFIGURATION_KEYS.manualImageTransactionPayment.id
    ],
    inOrganizationDetail: true
  }),
  apiContacts({
      active: true
    }),
  form({
    form: 'form-edit-payment-settings'
  })
)

class PaymentsConfig extends Component {
  static propTypes = {
    organizations: PropTypes.object.isRequired,
    permissions: PropTypes.object.isRequired,
    configuration: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    activeOrganization: PropTypes.object.isRequired,
    onGetConfigurationValues: PropTypes.func.isRequired,
    contacts: PropTypes.object
  }

  static defaultProps = {
    params: {}
  }

  componentDidMount = () => {
    const { permissions } = this.props

    if (!permissions.isLeader) {
      this.props.onGetConfigurationValues([
        CONFIGURATION_KEYS.directNaoBronze.id,
        CONFIGURATION_KEYS.directNaoSilver.id,
        CONFIGURATION_KEYS.directNaoGold.id,
        CONFIGURATION_KEYS.directOaBronze.id,
        CONFIGURATION_KEYS.directOaSilver.id,
        CONFIGURATION_KEYS.directOaGold.id,
        CONFIGURATION_KEYS.continuationNaoBronze.id,
        CONFIGURATION_KEYS.continuationNaoSilver.id,
        CONFIGURATION_KEYS.continuationNaoGold.id,
        CONFIGURATION_KEYS.continuationOaBronze.id,
        CONFIGURATION_KEYS.continuationOaSilver.id,
        CONFIGURATION_KEYS.continuationOaGold.id,
        CONFIGURATION_KEYS.continuationOaBronzeToGold.id,
        CONFIGURATION_KEYS.continuationNaoBronzeToGold.id,
        CONFIGURATION_KEYS.orgCurrency.id
      ])
    }
  }

  render() {
    const {
      organizations,
      permissions,
      configuration,
      params,
      activeOrganization
    } = this.props

    const organisationId = toNumber(params.id || activeOrganization.id)

    const hasOnlineGateway =
      get(
        configuration,
        `valuesByOrganizationId[${params.id}][${CONFIGURATION_KEYS.onlineMasterCardPayment.id}].booleanValue`
      ) ||
      get(
        configuration,
        `valuesByOrganizationId[${params.id}][${CONFIGURATION_KEYS.onlinePayPalPayment.id}].booleanValue`
      )||
        get(
            configuration,
            `valuesByOrganizationId[${params.id}][${CONFIGURATION_KEYS.gpWebPayPayment.id}].booleanValue`
        )

    return (
      <Form
        loading={configuration.loading}
        contentLoader={<ConfigLoader withTitle compact withTabs={false} />}
      >
        {!permissions.isLeader &&
          hasOnlineGateway &&
          <PaymentPrices
            {...this.props}
            parentOaId={get(organizations, 'detail.parentOA.id')}
          />}
        <PaymentMethods {...this.props} organisationId={organisationId} />
      </Form>
    )
  }
}

export default enhance(PaymentsConfig)
